import { CardActions } from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import { DesignToken } from '~/client/components/base/core';

export interface GenericCardActionsProps {
  className?: string;
  children: React.ReactNode;
  alignment?: 'left' | 'center' | 'right' | 'space-between';
  variant?: 'default' | 'minimal';
}

const GenericCardActionsImpl: React.FC<GenericCardActionsProps> = ({
  className,
  children,
  alignment = 'left',
  variant = 'default',
}) => {
  return <CardActions className={className}>{children}</CardActions>;
};

export const GenericCardActions = muiStyled(GenericCardActionsImpl)(
  ({ theme, alignment, variant }) => css`
    padding: ${theme.spacing(4)};
    margin-top: auto;

    ${variant === 'default' &&
    `
      background-color: #22222208;
      border-top: 1px solid ${DesignToken.borderSubtle};
    `}

    ${alignment === 'center' && `justify-content: center;`}
    ${alignment === 'right' && `justify-content: flex-end;`}
    ${alignment === 'space-between' && `justify-content: space-between;`}
    
    & .MuiButton-root {
      padding: 5px 21px;
      margin: 0;
    }
  `
);
